import { Paper } from "@mui/material";
import React, { useRef } from "react";
import Draggable from "react-draggable";

function DraggablePaper(props) {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-modal-handle"
      cancel={'input, textarea, button, select, .MuiSelect-select, .MuiRadio-root, .MuiCheckbox-root, .MuiSwitch-root, .MuiButton-root, .MuiIconButton-root, img, svg'}
    >
      <Paper 
        ref={nodeRef} 
        {...props} 
        style={{ ...props.style, margin: 0, maxHeight: '100%' }} 
      />
    </Draggable>
  );
}

export default DraggablePaper;